import React, { useState } from 'react';
import { Modal, AutoComplete } from 'antd';

const RelTypeSelect = (props) => {
	const [options, setOptions] = useState(props.pcodeList);
	const onSearch = (searchText) => {
		setOptions(
			!searchText ? props.pcodeList : props.pcodeList.filter(item => item.value.includes(searchText))
		);
	};
	const onSelect = (data) => {
		props.setStr('')
		props.setrelType(props.pcodeList.find(item => item.value === data));
	};
	const onChange = (data) => {
		props.setStr(data);
	};

	return (
		<AutoComplete
			allowClear
			autoFocus
			options={options}
			style={{
				width: 200,
			}}
			onSearch={onSearch}
			onSelect={onSelect}
			onChange={onChange}
			placeholder="input here"
		/>
	)
}

export const AddRelation = (props) => {
	const [str, setStr] = useState('');
	const [relType, setrelType] = useState({});

	const handleOk = () => {
		if (Object.keys(relType).length === 0) {
			if (str !== "") {
				props.addRelFunc(props.source, props.target, { id: "P" + new Date().getTime().toString(), value: str })
			} else {
				return
			}
		} else {
			if (!relType.id) {
				relType.id = "P" + new Date().getTime().toString()
			}
			props.addRelFunc(props.source, props.target, relType)
		}
		setStr('')
		setrelType({})
		props.showAddRel(false);
	};

	const handleCancel = () => {
		setStr('')
		setrelType({})
		props.showAddRel(false);
	};

	return (
		<Modal key={props.source.id + props.target.id} title="添加关系" open={props.isAddRelOpen} onOk={handleOk} onCancel={handleCancel}>
			<p>起始节点：{props.source.label}</p>
			<p>关系类型：<RelTypeSelect setrelType={setrelType} pcodeList={props.pcodeList} setStr={setStr} /></p>
			<p>终止节点：{props.target.label}</p>
		</Modal>
	);
};
